export interface ApiSuccess<T> {
  success: true;
  message: string;
  data: T;
}

export interface ApiFieldError {
  field?: string;
  message: string;
}

export interface ApiError {
  success: false;
  message: string;
  errors: ApiFieldError[];
}

/** Normalised error thrown by the api client for callers to catch. */
export class RequestError extends Error {
  readonly status: number;
  readonly errors: ApiFieldError[];
  readonly code?: string;

  constructor(message: string, status: number, errors: ApiFieldError[] = [], code?: string) {
    super(message);
    this.name = 'RequestError';
    this.status = status;
    this.errors = errors;
    this.code = code;
  }
}
